import { render, staticRenderFns } from "./Turnstile.vue?vue&type=template&id=2e20787a&"
import script from "./Turnstile.vue?vue&type=script&lang=js&"
export * from "./Turnstile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports